import { UseMutateAsyncFunction, useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';

import { DeleteUserProfileFieldRequestParams, queryClient } from 'api';
import { API_HANDLERS } from 'api/apiHandlers';
import { alert } from 'components';

interface UseDeleteUserProfileFieldMutationReturn {
  deleteUserProfileFieldMutation: UseMutateAsyncFunction<
    AxiosResponse<unknown, unknown>,
    unknown,
    DeleteUserProfileFieldRequestParams,
    unknown
  >;
  isLoading: boolean;
}

export function useDeleteUserProfileMutation(): UseDeleteUserProfileFieldMutationReturn {
  const { t } = useTranslation();

  const { mutateAsync: deleteUserProfileFieldMutation, isLoading } = useMutation(
    API_HANDLERS.SETTINGS.DELETE_USER_PROFILE_FIELD,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['user-profile-fields']);
        alert.success(t('toasts.fields.success.delete'));
      },
    },
  );

  return {
    deleteUserProfileFieldMutation,
    isLoading,
  };
}
